import React from "react";
import { Building2 } from "lucide-react";

const BG = "https://images.unsplash.com/photo-1614595737476-42487331b8a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBidWlsZGluZyUyMG1pbmltYWx8ZW58MHx8fHwxNzg2NzM4Nzk2fDA&ixlib=rb-4.1.0&q=85";

export default function Login() {
  const [expired, setExpired] = React.useState(false);
  React.useEffect(() => {
    try {
      if (window.sessionStorage.getItem("twp_session_expired")) {
        setExpired(true);
        window.sessionStorage.removeItem("twp_session_expired");
      }
    } catch (e) { if (process.env.NODE_ENV === "development") console.debug("Session-expired flag read skipped:", e); }
  }, []);

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-white">
      <div className="hidden lg:block relative">
        <img src={BG} alt="Architecture" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-zinc-900/40" />
        <div className="absolute bottom-0 left-0 p-12 text-white">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-white/70 mb-4">Private Studio Workspace</p>
          <h2 className="font-heading text-4xl font-black leading-tight max-w-md">Every drawing, task and deadline. In one place.</h2>
        </div>
      </div>

      <div className="flex items-center justify-center p-8 sm:p-16 grid-bg">
        <div className="w-full max-w-sm">
          <div className="flex items-center gap-3 mb-12">
            <img src="https://customer-assets-v7afamib.emergentagent.net/job_archi-interior-hub/artifacts/jmvnezz2_image.png"
              alt="TWP co" className="h-11 w-11 rounded-sm object-cover" />
            <div>
              <p className="font-heading font-extrabold text-lg leading-none tracking-tight">TWP co</p>
              <p className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 mt-1">Bringing design to life</p>
            </div>
          </div>

          {expired && (
            <div className="mb-6 rounded-sm border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800" data-testid="session-expired-notice">
              Your session expired. Please sign in again to continue.
            </div>
          )}

          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500 mb-2">Welcome back</p>
          <h1 className="font-heading text-4xl font-black tracking-tighter mb-3">Sign in</h1>
          <p className="text-zinc-500 mb-10 text-sm leading-relaxed">
            Access is restricted to your studio team. Sign in with your Google account below.
          </p>

          <button
            data-testid="google-login-button"
            onClick={handleLogin}
            className="w-full flex items-center justify-center gap-3 bg-zinc-900 text-white h-12 rounded-sm font-semibold text-sm hover:bg-zinc-800 transition-colors"
          >
            <svg className="h-5 w-5" viewBox="0 0 24 24">
              <path fill="#FFC107" d="M43.6 20.5h-1.9V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.1 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.3-.4-3.5z"/>
              <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.1 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/>
              <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.6 39.6 16.2 44 24 44z"/>
              <path fill="#1976D2" d="M43.6 20.5h-1.9V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C40.9 36.7 44 31 44 24c0-1.3-.1-2.3-.4-3.5z"/>
            </svg>
            Continue with Google
          </button>

          <p className="text-xs text-zinc-400 mt-8 leading-relaxed">
            Not on the team yet? Ask your studio admin to add your email before signing in.
          </p>
        </div>
      </div>
    </div>
  );
}
